import { format, isValid, formatRelative } from "date-fns";
import { enUS, enGB, de } from "date-fns/locale";

const locales = {
  "de-de": de,
  de: de,
  "en-gb": enGB,
  en: enGB,
  "en-us": enUS,
  "": de,
};

export default {
  formatIntoDateTime(datetimeString) {
    if (!datetimeString) {
      return datetimeString;
    }

    const datetime = new Date(datetimeString);

    if (isValid(datetime)) {
      let userLocaleAsString = (window.localLanguage || "").toLowerCase();
      let foundLocale = locales[userLocaleAsString];

      // try prefix of user locale
      if (!foundLocale && userLocaleAsString.length > 2) {
        foundLocale = locales[userLocaleAsString.substring(0, 2)];
      }

      // default locale
      if (!foundLocale) {
        foundLocale = locales["de"];
      }

      return format(datetime, "Pp", {
        locale: foundLocale,
      });
    }
    return datetimeString;
  },
};
